import { useTranslation } from 'react-i18next';
import type { Namespace } from '@/config/i18n';

/**
 * Type-safe wrapper around useTranslation
 * Provides better IDE support and future-proofing for custom logic
 */
export function useTypedTranslation<N extends Namespace = 'common'>(ns?: N) {
  return useTranslation(ns);
}
